/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetOutline {
    getFixupPrototypeFunction() { return WidgetOutline.fixupPrototype; }

    static newInstance(model: Partial<WidgetOutline>): WidgetOutline {
        let obj = Object.assign(new WidgetOutline(), model);
        WidgetOutline.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetOutline>): WidgetOutline {
        if (!model) return null;
        return WidgetOutline.newInstance(<WidgetOutline> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetOutline) {
        if (!obj) return;

        models.WidgetOutline.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetOutline): boolean {
        Object.setPrototypeOf(obj, WidgetOutline.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.left === undefined) {
            this.left = 0;
        }
        if (this.top === undefined) {
            this.top = 0;
        }
        if (this.width === undefined) {
            this.width = 0;
        }
        if (this.height === undefined) {
            this.height = 0;
        }
    }

    left: number;

    top: number;

    width: number;

    height: number;

}
